import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React from 'react';
export const WizIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="-4 -20 150 200">
    <path d="M74 0s-4.147 38.064-20.042 53.958C38.064 69.853 0 74 0 74s38.064 4.147 53.958 20.042C74 114.083 74 148 74 148s4.147-38.064 20.042-53.958C109.936 78.147 148 74 148 74s-38.064-4.147-53.958-20.042C78.147 38.064 74 0 74 0" />
  </SvgIcon>
);
